<template>
  <detail-section title="Property" :editable="editable" :commit="commit">
    <template #default="{isEditing}">
      <div class="d-flex flex-row align-items-start gap-2">
        <div class="d-flex flex-column gap-1 min-w-0 flex-grow-1">
          <template v-if="!isEditing">
            <div class="license-address text-truncate">
              {{ snapshotAddress }}
            </div>
            <AssessorLink :property="license.property" class="text-muted small" />
          </template>
          <template v-else>
            <PropertyInput
              :city="license.city"
              v-model="propertyId"
              size="sm"
              :show-labels="false"
            />
            <div class="text-muted small">
              <i class="bi-exclamation-triangle" /> Changing the property assigned to a license may alter the
              violation status of both the current property and the new property.
            </div>
          </template>
        </div>
      </div>
    </template>
  </detail-section>
</template>

<script>
import {License} from "@/models/License";
import PropertyInput from "@/components/common/PropertyInput.vue";
import DetailSection from "@/components/common/DetailSection.vue";
import AssessorLink from "@/components/common/AssessorLink.vue";
import {normalizeAddressLines} from "@/addressFormatting";

export default {
  components: {AssessorLink, DetailSection, PropertyInput},
  props: {
    license: License,
    editable: Boolean
  },
  data() {
    return {
      propertyId: null
    };
  },
  watch: {
    license: {
      immediate: true,
      handler() {
        this.propertyId = this.license.propertyId;
      }
    }
  },
  computed: {
    snapshotAddress() {
      const rawAddress = this.license?.addressFormatted || this.license?.unverifiedAddress;
      const [line1] = normalizeAddressLines(rawAddress);
      return line1 || rawAddress || 'Unknown address';
    }
  },
  methods: {
    async commit(note) {
      await this.license.updatePropertyId({
        propertyId: this.propertyId,
        note
      });
    }
  }
}
</script>

<style scoped>
.license-address {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
}
</style>
